import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
//import '../../../node_modules/video-react/dist/video-react.css';
import VideoPlayerCard from './VideoPlayerCard';

const VideoPlayerModal = (props) => {

	return (
		<span className="d-inline-block mb-2 mr-2">
			<Modal style={props.style} isOpen={props.isOpen} toggle={props.toggle} className={props.className}>
				<ModalHeader toggle={props.toggle}>Spela upp lektion</ModalHeader>
				<ModalBody>
					<VideoPlayerCard link={props.link} course={props.course} area={props.area} />
				</ModalBody>
				<ModalFooter>
					<Button color="link" onClick={props.toggle}>
						Stäng
					</Button>
				</ModalFooter>
			</Modal>
		</span>
	);
};

export default VideoPlayerModal
